import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const questionsModel = [
  {
    field: 'zalud_bacterialVaginosis_feverPelvicPain',
    label:
      'Do you have pelvic pain, lower abdominal pain, or fever along with your symptoms?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_bacterialVaginosis_soresUlcersBumps',
    label:
      'Have you noticed any sores, ulcers, blisters, or unusual bumps on your genitals?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_bacterialVaginosis_abnormalBleeding',
    label: 'Have you had vaginal bleeding between periods or after sex?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_bacterialVaginosis_retainedObject',
    label:
      'Could a tampon, condom, contraceptive ring, or other object be retained in the vagina?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' },
        { value: 'Not sure', key: 'not_sure' }
      ]
    }
  },
  {
    field: 'zalud_bacterialVaginosis_priorTreatmentFailed',
    label:
      'Have you completed a full course of BV treatment that did not resolve your symptoms?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_bacterialVaginosis_recentTreatmentReturned',
    label:
      'Have you been treated for BV in the past 3 months and had symptoms return?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_bacterialVaginosis_itchingBurningPrimary',
    label:
      'Are your main symptoms itching, burning, or irritation rather than discharge/odor?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_bacterialVaginosis_symptoms',
    label: 'What symptoms are you experiencing?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'Thin, milky grayish vaginal discharge',
          key: 'thin_milky_grayish_discharge'
        },
        { value: 'Fishy odor (especially after sex)', key: 'fishy_odor' },
        { value: 'Itching', key: 'itching' },
        { value: 'Burning', key: 'burning' },
        { value: 'Pain with urination', key: 'pain_with_urination' },
        { value: 'Pain with intercourse', key: 'pain_with_intercourse' },
        {
          value: 'Other',
          key: 'other',
          answer: {
            type: 'text',
            name: 'zalud_bacterialVaginosis_symptomsOther',
            placeholder: 'Please specify'
          }
        }
      ]
    }
  },
  {
    field: 'zalud_bacterialVaginosis_symptomLocation',
    label: 'Where are your symptoms located?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Outside/vulva', key: 'outside_vulva' },
        { value: 'Inside the vagina', key: 'inside_vagina' },
        { value: 'Around the anus', key: 'around_anus' },
        { value: 'Not sure', key: 'not_sure' }
      ]
    }
  },
  {
    field: 'zalud_bacterialVaginosis_symptomOnset',
    label: 'When did symptoms start?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'zalud_bacterialVaginosis_symptomOnset'
    }
  },
  {
    field: 'zalud_bacterialVaginosis_odorAfterIntercourse',
    label: 'Is the odor more noticeable after sexual intercourse?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' },
        { value: 'Not applicable', key: 'not_applicable' }
      ]
    }
  },
  {
    field: 'zalud_bacterialVaginosis_priorBVDiagnosis',
    label: 'Have you had a similar episode diagnosed as BV before?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes, once', key: 'yes_once' },
        {
          value: 'Yes, several times in the past 12 months',
          key: 'yes_several_times_past_12_months'
        },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_bacterialVaginosis_menstrualCycleTiming',
    label:
      'Did your symptoms start around the same time as your menstrual cycle?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' },
        { value: 'Not sure', key: 'not_sure' }
      ]
    }
  },
  {
    field: 'zalud_bacterialVaginosis_sexuallyActive',
    label:
      'Are you currently sexually active (this and the following questions will help us better understand how to treat your symptoms)?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_bacterialVaginosis_numPartners3Months',
    label:
      'How many sexual partners have you had in the last 3 months (including foreplay and intercourse)?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: '0', key: '0' },
        { value: '1', key: '1' },
        { value: '2-3', key: '2_to_3' },
        { value: '4+', key: '4_plus' }
      ]
    }
  },
  {
    field: 'zalud_bacterialVaginosis_newPartner3Months',
    label: 'Have you had a new sexual partner in the past 3 months?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_bacterialVaginosis_partnerSex',
    label: 'What sex(es) is/are your partner(s)?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Male', key: 'male' },
        { value: 'Female', key: 'female' },
        { value: 'Both', key: 'both' }
      ]
    }
  },
  {
    field: 'zalud_bacterialVaginosis_barrierProtectionFrequency',
    label:
      'How often do you use barrier protection (condoms, diaphragms) during foreplay or intercourse?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Never', key: 'never' },
        { value: 'Sometimes', key: 'sometimes' },
        { value: 'Always', key: 'always' },
        { value: 'Not applicable', key: 'not_applicable' }
      ]
    }
  },
  {
    field: 'zalud_bacterialVaginosis_partnerSTISymptoms',
    label:
      'Does any recent partner have genital symptoms or was recently diagnosed with an STI?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' },
        { value: 'Not sure', key: 'not_sure' }
      ]
    }
  },
  {
    field: 'zalud_bacterialVaginosis_hygieneProducts',
    label: 'Do you douche or use vaginal hygiene products (washes, sprays, wipes)?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes, douche', key: 'yes_douche' },
        {
          value: 'Yes, washes, sprays or wipes',
          key: 'yes_washes_sprays_wipes'
        },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_bacterialVaginosis_iud',
    label: 'Do you use an IUD?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes, hormonal', key: 'yes_hormonal' },
        { value: 'Yes, copper', key: 'yes_copper' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_bacterialVaginosis_stiTestedRecently',
    label: 'Have you been tested for STIs recently?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes, with negative results for an STI',
          key: 'yes_negative'
        },
        {
          value: 'Yes, with positive results for an STI',
          key: 'yes_positive'
        },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_bacterialVaginosis_stiDiagnosed',
    label: 'Which STI were you recently diagnosed with?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'zalud_bacterialVaginosis_stiDiagnosed'
    }
  },
  {
    field: 'zalud_bacterialVaginosis_treatmentPreference',
    label:
      "If your doctor decides treatment for BV is needed, do you have a preference for the type of treatment prescribed?",
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Oral (by mouth)', key: 'oral' },
        {
          value: 'Intra-vaginal (vaginal suppository)',
          key: 'intra_vaginal'
        },
        {
          value: 'No preference (whatever the doctor feels is best)',
          key: 'no_preference'
        }
      ]
    }
  },
  {
    field: 'zalud_bacterialVaginosis_priorTreatmentEffectiveness',
    label:
      "If you've been treated for BV before, was there a treatment that worked well or poorly for you?",
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'zalud_bacterialVaginosis_priorTreatmentEffectiveness'
    }
  },
  {
    field: 'zalud_bacterialVaginosis_additionalComments',
    label:
      'Are there any additional symptoms or comments related to your current condition that were not covered in this form?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'zalud_bacterialVaginosis_additionalComments'
    }
  },
  {
    field: 'zalud_bacterialVaginosis_consent',
    label: 'Consent',
    type: 'select',
    educationalSlide: `I consent that by submitting this form I acknowledge that the responses are truthful and accurate to the best of my knowledge, and understand that if I am or become pregnant, or use medications off-label, I should consult a qualified health care professional for individualized guidance.`,
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I have read the information and I DO NOT wish to proceed',
          class: 'option-decline',
          key: 'do_not_proceed'
        },
        {
          value:
            'I have read and understand the information and I wish to proceed',
          class: 'option-consent',
          key: 'proceed'
        }
      ]
    }
  },
  {
    field: 'zalud_bacterialVaginosis_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    type: 'info',
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'zalud_bacterialVaginosis_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to continue based on your responses.",
    blockQuestionFlow: true,
    answer: {},
    type: 'info',
    isLast: true
  }
] as const;

export type ZaludBacterialVaginosisQuestionFieldAnswers = Partial<
  QuestionAnswerMap<typeof questionsModel>
>;
export default questionsModel;
